<template>
  <div class="deal-item-options">
    <a
      ref="googleMaps"
      class="btn btn--ghost btn--ghost--white"
      target="_blank"
      :href="googleMapsUrl"
      >{{ $t('WIZARD.LIST.GO_TO_GOOGLE_MAPS') }}</a
    >
    <a
      ref="preisatlas"
      class="btn btn--ghost btn--ghost--white"
      target="_blank"
      :href="preisatlasUrl"
      >{{ $t('WIZARD.LIST.GO_TO_PREISATLAS') }}</a
    >
    <hd-input
      ref="dealSuggestedSquareMeterPrice"
      v-model="suggestedSqmPrice"
      class="deal-item-options__suggested-square-meters"
      type="number"
      name="deal-suggested-square-meters-price"
      :label="$t('WIZARD.LIST.SQUARE_METERS_PRICE')"
    />
  </div>
</template>

<script>
// Components
import { HdInput } from 'homeday-blocks';
// Constants
import { MUTATION } from '@/store/CONSTANTS';

export default {
  name: 'DealItemOptions',
  components: {
    HdInput,
  },
  props: {
    deal: {
      type: Object,
      required: true,
    },
  },
  computed: {
    suggestedSqmPrice: {
      set(value) {
        this.$store.commit(MUTATION.WIZARD.CURRENT_DEAL.SET_SUGGESTED_SQM_PRICE, value);
        this.$store.commit(MUTATION.WIZARD.UPDATE_DEAL_PROPERTIES, {
          uid: this.deal.uid,
          properties: {
            suggestedSqmPrice: value,
          },
        });
      },
      get() {
        return this.deal.suggestedSqmPrice;
      },
    },
    googleMapsUrl() {
      return this.deal.googleMapsUrl;
    },
    preisatlasUrl() {
      return this.deal.preisatlasUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';
.deal-item-options {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;
  height: 100%;

  @include for('mobile-only') {
    flex-direction: column;
  }

  .btn {
    color: $primary-color;
    border-color: $primary-color;

    @include for('mobile-only') {
      width: 100%;
    }
  }

  &__suggested-square-meters {
    margin-bottom: 0;

    @include for('tablet') {
      max-width: 180px;
    }
  }

  > * {
    margin-left: $sp-m;
    margin-top: $sp-m;
  }
}
</style>
